import { Route } from '@angular/router';

import { UserResolver, UserRolesResolver } from './resolvers';

export const userRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./user-list/user-list.component').then((c) => c.UserListComponent),
  },
  {
    path: 'new',
    resolve: {
      roles: UserRolesResolver,
    },
    loadComponent: () => import('./user-detail/user-detail.component').then((c) => c.UserDetailComponent),
  },
  {
    path: ':id',
    resolve: {
      roles: UserRolesResolver,
      user: UserResolver,
    },
    loadComponent: () => import('./user-detail/user-detail.component').then((c) => c.UserDetailComponent),
  },
];
